module.exports = "/static/assets/96bb35bb5da9e2a531633aeabae12a4b.png";